// extracted by mini-css-extract-plugin
export default {"coffeeReviews":"CoffeeReviews_coffeeReviews__1mQ9t","title":"CoffeeReviews_title__wCm3w","btn":"CoffeeReviews_btn__vYURM"};